export default "__VITE_ASSET__CMQI3KKn__"